import Component from '../colorz/Component';

export default class ProductStickyBar extends Component {
	onInit(el) {
		this.el = el;
		this.stickyBtn = null;
	}
	onReady() {
		this.initValue();
		this.observer();
	}
	initValue() {
		this.stickyBtn = document.querySelector('.js-product-sticky-bar');
	}
	observer() {
		this.intersectionObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio >= 0.01) {
						if (this.stickyBtn) {
							this.stickyBtn.classList.add(
								'u-invisible',
								'u-pointer-events-none',
								'u-translate-y-full',
							);
						}
					}
					if (entry.intersectionRatio <= 0.1) {
						if (this.stickyBtn) {
							this.stickyBtn.classList.remove(
								'u-invisible',
								'u-pointer-events-none',
								'u-translate-y-full',
							);
						}
					}
				});
			},
			{
				rootMargin: '0px 0px 0px 0px',
				threshold: [0.0, 0.1, 1.0],
			},
		);
		this.intersectionObserver.observe(this.el);
	}
}
